/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

export type Order = 'asc' | 'desc';

export enum Currency {
    BYN = 'BYN',
    USD = 'USD',
    AZN = 'AZN',
}

export interface AddressResource {
    region: string;
    locality: string;
    city: string;
    postCode: string;
    street: string;
    building: string;
}

export interface ListResource<T> {
    data: T[];
    count: number;
}

export interface PageQueryParams {
    limit: number;
    offset: number;
}

export interface AfterKeyPageQueryParams {
    afterKey: string;
    limit?: number;
}

export interface SortQueryParams {
    sort?: string;
}

export interface SortQueryParamsGeneric<T> {
    sortType: T;
    sortOrder: Order;
}

export interface SearchQueryParams {
    search_type: string;
    search_text: string;
}

export interface PeriodQueryParams {
    dateFrom: string;
    dateTo: string;
}

export enum TurnoversByPeriodGroupType {
    YEAR = 'YEAR',
    MONTH = 'MONTH',
    DAY = 'DAY',
}

export interface TurnoversByPeriodQueryParams {
    group: TurnoversByPeriodGroupType;
    year?: string;
    month?: string;
}

export type TurnoversByObjectsQueryParams = PageQueryParams & PeriodQueryParams;

export type TurnoversByCashBoxesQueryParams = PageQueryParams & PeriodQueryParams;

export type TurnoversByPeriodEXCELParams = { year: string };

export type TurnoversByTaxEntityEXCELParams = PeriodQueryParams;

export interface RegistryTurnoversBase {
    sales: {
        count: number;
        sum: number;
    };
    corrections: {
        count: number;
        sum: number;
    };
    moneybacks: {
        count: number;
        sum: number;
    };
    rollbacks: {
        count: number;
        sum: number;
    };
    cash: number;
    cashless: number;
    bonus: number;
    prepayment: number;
    credit: number;
    vatSum: number;
    turnover: number;
    currency: string;
}

export interface RegistryTurnoversByPeriodDto extends RegistryTurnoversBase {
    date: string;
}

export interface RegistryTurnoversByCashBox extends RegistryTurnoversBase {
    taxNumber: string;
}

export interface RegistryTurnoversByObject extends RegistryTurnoversBase {
    taxNumber: string;
    name: string;
}

export interface TurnoversByPeriodWithParams {
    turnovers: RegistryTurnoversByPeriodDto[];
    params: TurnoversByPeriodQueryParams;
}

export interface DayTurnover {
    daySum: RegistryTurnoversByPeriodDto;
    day: string;
}

export interface MonthTurnover {
    monthSum: RegistryTurnoversByPeriodDto;
    month: string;
    isHiddenDaysList: boolean;
    daysTurnovers: DayTurnover[];
}

export interface YearTurnover {
    yearSum: RegistryTurnoversByPeriodDto;
    year: string;
    isHiddenMonthsList: boolean;
    monthsTurnovers: MonthTurnover[];
}

export interface EntirePeriodTurnover {
    yearsTurnovers: YearTurnover[];
}

export interface RegistryTurnoversByCashBoxesDto {
    count: number;
    turnovers: RegistryTurnoversByCashBox[];
}

export interface RegistryTurnoversByObjectsDto {
    count: number;
    turnovers: RegistryTurnoversByObject[];
}

export interface PageParams {
    pageSize: number;
    page: number;
}
